import { AssessmentResultsCode, AssessmentScores } from "@store/generalTypes";

export const showTotalLearningUninterpretableSummary = (score: AssessmentScores): boolean => {
    return score.totalLearning !== undefined && score.totalLearning.result === AssessmentResultsCode.Impaired;
};

export const showTotalLearningBorderlineSummary = (score: AssessmentScores): boolean => {
    return score.totalLearning !== undefined && score.totalLearning.result === AssessmentResultsCode.Borderline;
};

export const noTotalLearningSummary = (score: AssessmentScores): boolean => {
    return !showTotalLearningBorderlineSummary(score) && !showTotalLearningUninterpretableSummary(score);
};

export const showImpairedCuedRecallSummary = (score: AssessmentScores): boolean => {
    return (
        noTotalLearningSummary(score) &&
        !showImpairedIntrusionsPIERatioSummary(score) &&
        score.b1CuedRecall !== undefined &&
        score.b2CuedRecall !== undefined &&
        (score.b1CuedRecall.result === AssessmentResultsCode.Impaired ||
            score.b2CuedRecall.result === AssessmentResultsCode.Impaired)
    );
};

export const showImpairedIntrusionsPIERatioSummary = (score: AssessmentScores): boolean => {
    return (
        noTotalLearningSummary(score) &&
        score.b1Intrusions !== undefined &&
        score.b2CuedIntrusions !== undefined &&
        score.pieRatio !== undefined &&
        score.pieRatio.result === AssessmentResultsCode.Impaired
    );
};

export const showImpairedTwoMarginalSummary = (score: AssessmentScores): boolean => {
    return (
        noTotalLearningSummary(score) &&
        score.b1CuedRecall !== undefined &&
        score.b1Intrusions !== undefined &&
        score.b2CuedIntrusions !== undefined &&
        score.b2CuedRecall !== undefined &&
        numberImpaired(score) === 0 &&
        numberMarginal(score) > 1
    );
};

export const showImpairedAnyReason = (score: AssessmentScores): boolean => {
    return (
        showImpairedCuedRecallSummary(score) ||
        showImpairedIntrusionsPIERatioSummary(score) ||
        showImpairedTwoMarginalSummary(score)
    );
};

export const showMarginalOneItemSummary = (score: AssessmentScores): boolean => {
    return (
        noTotalLearningSummary(score) &&
        score.b1CuedRecall !== undefined &&
        score.b1Intrusions !== undefined &&
        score.b2CuedIntrusions !== undefined &&
        score.b2CuedRecall !== undefined &&
        numberImpaired(score) === 0 &&
        numberMarginal(score) === 1
    );
};

export const showImpairedPerformanceOnListBIntrusions = (score: AssessmentScores): boolean => {
    return (
        noTotalLearningSummary(score) &&
        !showImpairedCuedRecallSummary(score) &&
        score.b1Intrusions !== undefined &&
        score.b2CuedIntrusions !== undefined &&
        score.pieRatio !== undefined &&
        score.pieRatio.result === AssessmentResultsCode.Normal &&
        (score.b1Intrusions.result === AssessmentResultsCode.Impaired ||
            score.b2CuedIntrusions.result === AssessmentResultsCode.Impaired)
    );
};

export const showResultNormal = (score: AssessmentScores): boolean => {
    return (
        !showTotalLearningUninterpretableSummary(score) &&
        !showTotalLearningBorderlineSummary(score) &&
        !showImpairedCuedRecallSummary(score) &&
        !showImpairedIntrusionsPIERatioSummary(score) &&
        !showImpairedTwoMarginalSummary(score) &&
        !showMarginalOneItemSummary(score) &&
        !showImpairedPerformanceOnListBIntrusions(score)
    );
};

const numberImpaired = (score: AssessmentScores): number => {
    let ret = 0;
    if (score.b1CuedRecall?.result === AssessmentResultsCode.Impaired) ret++;
    if (score.b1Intrusions?.result === AssessmentResultsCode.Impaired) ret++;
    if (score.b2CuedRecall?.result === AssessmentResultsCode.Impaired) ret++;
    if (score.b2CuedIntrusions?.result === AssessmentResultsCode.Impaired) ret++;
    if (score.pieRatio?.result === AssessmentResultsCode.Impaired) ret++;
    return ret;
};

const numberMarginal = (score: AssessmentScores): number => {
    let ret = 0;
    if (score.b1CuedRecall?.result === AssessmentResultsCode.Borderline) ret++;
    if (score.b1Intrusions?.result === AssessmentResultsCode.Borderline) ret++;
    if (score.b2CuedRecall?.result === AssessmentResultsCode.Borderline) ret++;
    if (score.b2CuedIntrusions?.result === AssessmentResultsCode.Borderline) ret++;
    if (score.pieRatio?.result === AssessmentResultsCode.Borderline) ret++;
    return ret;
};
